module.exports = __webpack_public_path__ + "img/10.2d237c27.jpg";